import { CREATE_MESSAGE } from "../actions/actionTypes";

const initialState = {
  messages: [],
};

export default function messagesReducer(state = initialState, action) {
  switch (action.type) {
    case CREATE_MESSAGE:
      return {
        ...state,
        messages: action.payload,
      };
    default:
      return state;
  }
}
